const VALID_PHONE_FORMAT = /^(\d{1})?[ ]?\(*\d{3}\)*[ ]*\d{3}[-]*(\d{4})$/
const VALID_POSTAL_FORMAT = /(^\d{5}$)|(^\d{5}-\d{4}$)|(^[ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ] ?[0-9][ABCEGHJKLMNPRSTVWXYZ][0-9])$/
const VALID_EMAIL_FORMAT = /^(['+\-.\w]+)@((\w[+\-.\w]*)\.[\w]{2,})$/
const VALID_CANADA_POSTAL_FORMAT = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/
const VALID_US_POSTAL_FORMAT = /^(?!00000)\d{5}(?:[-\s](?!0000)\d{4})?$/

const VALID_DEVICE_ID_REGEX = /^(LT[0-9]{6}|LTFP[0-9]{6}|[0-9A-F]{8}|[0-9]{4}[0-9A-Z]{6}|[0-9A-F]{12}|C\d{2}[A-HJ-M]\d{5})$/
const VALID_HEHM_DEVICE_ID_REGEX = /^(A0T[0-9]{1}[A-Z0-9]{8})$/

export const isDeviceIdValid = (deviceId) => deviceId && deviceId.match(VALID_DEVICE_ID_REGEX)
export const isHEHMDeviceIdValid = (deviceId) => deviceId && deviceId.match(VALID_HEHM_DEVICE_ID_REGEX)
export const isPhoneValid = (phone) => !!phone.match(VALID_PHONE_FORMAT)
export const isZipValid = (zip) => !!zip.match(VALID_POSTAL_FORMAT)
export const isUSZipValid = (zip) => !!zip.match(VALID_US_POSTAL_FORMAT)
export const isCanadaPostalValid = (postal) => !!postal.match(VALID_CANADA_POSTAL_FORMAT)
export const isEmailValid = (email) => !!email.match(VALID_EMAIL_FORMAT)
